// src/hooks/useEventManager.ts
/**
 * Event 管理 Hook
 *
 * 處理 Event Detail 的模態框控制（ID-based 模式）
 * EventDetail 內部使用 useEventDetail 處理更新和刪除
 */
import { useState, useCallback } from 'react';

export interface UseEventManagerReturn {
  // EventDetail 狀態
  showEventDetail: boolean;
  selectedEventId: string | null;
  // 方法
  openEventDetail: (eventId: string) => void;
  closeEventDetail: () => void;
}

export function useEventManager(): UseEventManagerReturn {
  // EventDetail 狀態（ID-based）
  const [showEventDetail, setShowEventDetail] = useState<boolean>(false);
  const [selectedEventId, setSelectedEventId] = useState<string | null>(null);

  /**
   * 開啟 EventDetail（ID-based）
   */
  const openEventDetail = useCallback((eventId: string) => {
    setSelectedEventId(eventId);
    setShowEventDetail(true);
  }, []);

  /**
   * 關閉 EventDetail
   */
  const closeEventDetail = useCallback(() => {
    setShowEventDetail(false);
    setSelectedEventId(null);
  }, []);

  return {
    showEventDetail,
    selectedEventId,
    openEventDetail,
    closeEventDetail,
  };
}
